// extracted by mini-css-extract-plugin
module.exports = {"PurchaseProduct":"PurchaseProduct_PurchaseProduct__1BFdh","container":"PurchaseProduct_container__28Ma6"};